<template>
  <!-- BEGIN: Content-->
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top profile__avatar">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                {{ title }}
              </h2>
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Host history settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="data"
              :sort-mapping="sortMapping"
              :title="'promotion histories'"
              :total="dataTotal"
              :fetch-path="'promotionHistory/fetch'"
              :filter-path="'promotionHistory/filter'"
            >
              <template v-slot="{field}">
                <td
                  class="text-end"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="p-0"
                    right
                  >
                    <template #button-content>
                      <i data-feather="more-vertical" />
                    </template>
                    <div
                      class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                    >
                      <b-dropdown-item
                        @click="$router.push({name: 'researcher.administration.promotion-history.see-evaluation', params: {
                          user: field.applicant.id,
                          convo: field.promotion.id
                        }})"
                      >
                        <i
                          class="me-50"
                          data-feather="user"
                        /> View evaluation
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="field.hasDocument && field.hasDocument.includes('Upload')"
                        @click="showDocument(field.salary_history)"
                      >
                        <i
                          class="me-50"
                          data-feather="book-open"
                        /> View document
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                  <a
                    href=""
                    class="btn btn-icon btn-light-secondary d-block d-sm-none"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMenu"
                    aria-controls="offcanvasBottom"
                  ><i
                    data-feather="more-vertical"
                  /></a>
                </td>
              </template>
              <template #customfilters>
                <div
                  v-if="loggedUser.roles.includes('super-admin')"
                  class="mb-1"
                >
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Researcher</label>
                  <v-select
                    label="name"
                    :options="users"
                    :get-option-key="option => option.id"
                    @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
                    @input="saveFilter($event, 'researcher')"
                  />
                  <hr>
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Year</label>
                  <date-picker
                    v-model="filters['begin_year']"
                    format="Y"
                    type="year"
                    value-type="format"
                    class="w-100"
                    @change="saveFilter($event, 'year')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Levels</label>
                  <input
                    type="number"
                    min="1"
                    max="5"
                    class="form-control"
                    @change="saveFilter($event.target.value, 'levels')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Evaluation</label>
                  <v-select
                    label="name"
                    :options="[
                      { name: 'Evaluation - Unacceptable', value: '1' },
                      { name: 'Evaluation - Inadequate', value: '2' },
                      { name: 'Evaluation - Fair', value: '3' },
                      { name: 'Evaluation - Very good', value: '4' },
                      { name: 'Evaluation - Outstanding', value: '5' },
                    ]"
                    :get-option-key="option => option"
                    @input="saveFilter($event, 'grade')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Result</label>
                  <v-select
                    label="name"
                    :options="[
                      { name: 'Result - Positive', value: '1' },
                      { name: 'Result - Negative', value: '0' },
                    ]"
                    :get-option-key="option => option"
                    @input="saveFilter($event, 'result')"
                  />
                </div>
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >With document</label>
                  <v-select
                    label="name"
                    :options="[
                      { name: 'With files - Yes', value: '1' },
                      { name: 'With files - No', value: '0' },
                    ]"
                    :get-option-key="option => option"
                    @input="saveFilter($event, 'with_document')"
                  />
                </div>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import vSelect from 'vue-select'
import CompleteTable from '../../../partials/components/CompleteTable.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    vSelect,
    DatePicker,
  },
  data() {
    return {
      filters: [],
      sortedField: 'Researcher',
      defaultFields: [
        {
          name: 'Researcher',
          checked: true,
          order: 1,
        },
        {
          name: 'Year',
          checked: true,
          order: 2,
        },
        {
          name: 'Levels',
          checked: true,
          order: 3,
        },
        {
          name: 'Evaluation',
          checked: true,
          order: 4,
        },
        {
          name: 'Result',
          checked: true,
          order: 5,
        },
        {
          name: 'Document',
          checked: true,
          order: 6,
        },
      ],
      sortMapping: {
        Researcher: 'applicant.name',
        Year: 'promotion.year',
        Levels: 'levels',
        Evaluation: 'evaluation_table',
        Result: 'result',
        Document: 'hasDocument',
      },
      title: 'Promotion history',
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      data: 'promotionHistory/items',
      dataTotal: 'promotionHistory/itemsTotal',
      users: 'users/fakeUsers',
      loggedUser: 'auth/admin',
      hosts: 'institutions/institutions',
      filtersAux: 'filters/filters',
    }),
  },
  async mounted() {
    await this.$store.dispatch('modals/fetchUserFields', 'promotion_histories')
    await this.$store.dispatch('promotionHistory/filter', this.filtersAux)
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'promotion_histories',
      })
    }
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    saveFilter(value, field) {
      this.filters[field] = value
      this.$store.dispatch('filters/saveFilters', {
        value,
        field,
      })
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
    showDocument(url) {
      window.open(url.files_[0].url, '_blank')
    },
  },
}
</script>
